<template>
  <div>
    <ai-chat-panel />
  </div>
</template>

<script>
import AIChatPanel from "../../components/ai/AIChatPanel.vue";

export default {
  name: "AIChatPage",
  components: {
    "ai-chat-panel": AIChatPanel,
  },
};
</script>